A monetary amount of remuneration in a specified currency for a position to be previewed prior to posting.
